import Tooltip from '@components/Tooltips/Tooltip';
import { useI18n } from '@i18n/useI18n';
import { useStore } from '@store/appStore';
import {
  Backdrop,
  CloseButton,
  Content,
  DateContainer,
  DateSelectButton,
  DateSelectContainer,
  Exclamation,
  FilterMenu,
  HeaderText,
  SelectButton,
} from './Filter.styled';
import Cross from '@assets/svg/plus.svg';
import { useEffect, useState } from 'react';
import moment from 'moment';
import DatePick from '@components/Buttons/DatePick';
import { useRouter } from 'next/router';
import db from '@utils/db';
import CounselorPageList from '@components/CounselorPage/CounselorPageList';

interface Props { }

export const Filter = (props: Props) => {
  const { settings, filterOpen, setFilterOpen, setFilterDate, filterDate, client, semesters, setFilterWarning, filterWarning, groups, setActiveFilter, activeFilter, dateFilter, setDateFilter, systemSettings, selectedSemester } = useStore();
  const i18n = useI18n();
  const [dates, setDates] = useState({ from: moment().add(-6, 'months').format('YYYY-MM-DD'), to: moment().format('YYYY-MM-DD') });
  const router = useRouter();

  let schoolleader = groups?.includes(client?.SchoolLeaderGroupName)
  let allowCustomDates = systemSettings?.find((s) => s.APP_Setting_ID === 90);

  useEffect(() => {
    if (semesters) {
      let currentFilter = sessionStorage.getItem('dateFilter');
      handleSemesters(settings.SAVESEMESTER === true ? null : currentFilter);
    }
  }, [semesters, systemSettings, settings]);

  const handleSemesters = async (currentFilter) => {
    let index = selectedSemester
    if ((selectedSemester === null || settings.SAVESEMESTERS === false)) {
      let periodType = systemSettings?.find((s) => s.APP_Setting_ID === 39);
      let defaultPeriod = systemSettings?.find((s) => s.APP_Setting_ID === 92);
      if (periodType?.value === '3' && defaultPeriod?.value?.toUpperCase() === 'SEMESTER') index = 2;
      else index = semesters.length - 1;
    }

    if (index <= semesters.length - 1) index = index
    else index = semesters.length - 1    

    let singleSemester = semesters[index];
    if (currentFilter) {
      let cf = JSON.parse(currentFilter);
      HandleDateFilter(cf.index, cf.text, cf.year, cf.from, cf.to, cf.isDateFilter);
    } else {
      HandleDateFilter(
        Number(index),
        singleSemester.text,
        singleSemester.year,
        singleSemester.fromDate,
        singleSemester.toDate,
        true,
      );
    }
  }

  const HandleDateFilter = async (index, text, year, from, to, isDateFilter?, click?) => {
    let singleSemester = semesters[semesters.length - 1];
    let periodType = systemSettings?.find((s) => s.APP_Setting_ID === 39);
    let defaultPeriod = systemSettings?.find((s) => s.APP_Setting_ID === 92);
    console.log(defaultPeriod)
    let defaultIndex = semesters.length - 1;
    if (periodType?.value === '3' && defaultPeriod?.value?.toUpperCase() === 'SEMESTER') defaultIndex = 2;

    if (
      (periodType?.value === '3' && index !== defaultIndex) || ((index !== semesters.length - 1 ||
        text !== singleSemester.text ||
        year !== singleSemester.year ||
        from !== singleSemester.fromDate ||
        !isDateFilter) && (periodType?.value !== '3'))
    ) {
      setFilterWarning(true);
    } else {
      setFilterWarning(false);
    }
    setDateFilter(isDateFilter === true);
    if (text.includes('fall') || text.includes('spring')) {
      setFilterDate(text, year, from, moment(to).isAfter(moment().format('YYYY-MM-DD')) ? moment().format('YYYY-MM-DD') : to, to);
    } else {
      setFilterDate(text, year, from, moment(to).isAfter(moment().format('YYYY-MM-DD')) ? moment().format('YYYY-MM-DD') : to, to);
    }

    if (isDateFilter === true && click && settings.SAVESEMESTERS === true && index !== 0) {
      await db.setUserSetting(client.UserName + "@" + client.Domain, 25, index, false)
      sessionStorage.removeItem('dateFilter');
    }

    if (isDateFilter === false || (isDateFilter && settings.SAVESEMESTERS === false)) {
      sessionStorage.setItem('dateFilter', JSON.stringify({ index, text, year, from, to, isDateFilter: isDateFilter === true, enddate: to }));
    }
    setActiveFilter(index);
    setFilterOpen(false);
  };

  const HandleSelectedFilterDate = (e, type) => {
    if (type === 1) {
      setDates({ from: moment(e).format('YYYY-MM-DD'), to: dates.to });
    }
    if (type === 2) {
      if (moment(moment(e)).isSameOrBefore(dates.from)) {
        setDates({ from: moment(e).add(-1, 'day').format('YYYY-MM-DD'), to: moment(e).format('YYYY-MM-DD') });
      } else {
        setDates({ from: dates.from, to: moment(e).format('YYYY-MM-DD') });
      }
    }
  };

  let filterButtons = [];
  semesters?.map((f, index) => {
    filterButtons.push(
      <Tooltip key={index + 'filter'} content={index === 0 && schoolleader && router.pathname === "/" ? "" : i18n.t(f.tooltip, { year: f.year })} placement={'bottom-center'}>
        <SelectButton disabled={index === 0 && schoolleader && router.pathname === "/" ? true : false} onClick={() => HandleDateFilter(index, f.text, f.year, f.fromDate, f.toDate, true, true)} active={activeFilter === index}>
          {i18n.t(f.text, { year: f.year })}
        </SelectButton>
      </Tooltip>,
    );
  });

  return (
    <FilterMenu open={filterOpen}>
      <CloseButton onClick={() => setFilterOpen(false)}>
        <Cross />
      </CloseButton>
      <Content>
        <HeaderText>{i18n.t('filter-header1')}</HeaderText>

        {filterButtons}

        {allowCustomDates?.value?.toLowerCase() === "true" ?
          <>
            <HeaderText>
              {i18n.t('filter-header2')}

              <Tooltip content={i18n.t('filter-header2-tooltip')} offsetX={5}>
                <Exclamation />
              </Tooltip>
            </HeaderText>


            <DateSelectContainer>
              <DateContainer>
                <p>{i18n.t('export-from')}:</p>
                <DatePick
                  date={moment(dates.from)}
                  max={moment(dates.to).add(-1, 'day')}
                  handleOnChange={HandleSelectedFilterDate}
                  type={1}
                  tooltip={i18n.t('filter-from')}
                  isActive={!dateFilter}
                />
              </DateContainer>
              <DateContainer>
                <p>{i18n.t('export-to')}:</p>
                <DatePick
                  date={moment(dates.to)}
                  max={moment()}
                  handleOnChange={HandleSelectedFilterDate}
                  type={2}
                  tooltip={i18n.t('filter-to')}
                  isActive={!dateFilter}
                />
              </DateContainer>
              <DateSelectButton onClick={() => HandleDateFilter(-1, 'filter-text-custom', '', dates.from, dates.to, false)}>
                {i18n.t('filter-apply')}
              </DateSelectButton>
            </DateSelectContainer></> : null}
      </Content>
      <Backdrop />
    </FilterMenu>
  );
};

export default Filter;
